module.exports = __webpack_public_path__ + "media/svg-new/avatar01-46fff469.svg";